import Accordion from "../../../components/accordion";
import ModalForm from "../../../components/base/forms/modal-form";
import ServiceLocator from "../../../global/service-locator";
export default class PageModule {
    constructor() {
        this.sl = ServiceLocator.instance;

        this.initForm();
        this.initAccordion();
    }

    initForm() {
        const $modalTriggers = document.querySelectorAll('[data-modal-trigger="itgen-registration"]');

        const form = new ModalForm({
            formId: 'itgen-registration',
            uri: '/1.0/itgen/registration',
            data: {
                referrer: location.href,
                fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
                fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null
            },
            $modalTriggers: [...$modalTriggers],
        });

        this.sl.eventEmitterService.subscribe('event:header-loaded', () => {
            form.changeTriggers(Array.from(document.querySelectorAll('[data-modal-trigger="itgen-registration"]')));
        });
    }

    initAccordion() {
        new Accordion('accordion-faq');
    }
}